(function ($) {
    $(document).ready(function () {
        $('.start-application-button').click(function (e) {
            console.log('Start application button clicked');
        });
    });
})(jQuery);